export default "__VITE_ASSET__Cn58ZuiF__"